<template>
  <div id="chart-line" v-loading="chartLoading" style="position: relative">
    <apexchart ref="apexEnvelope" id="apexEnvelope" v-observe-visibility="visibilityChanged" type="line" height="360"
      :options="chartOptions" :series="series"></apexchart>
    <ChartTimeMini :unit="sensorUnit" :rawData="rawData" :samplingRate="samplingRate" v-model="visibleRange"
      v-on:childTimeDomain="updateTimeChartMinMax"></ChartTimeMini>
    <div style="
                order: 0;
                position: absolute;
                top: 0;
                justify-content: center;
                align-items: center;
                display: flex;
                flex-direction: row;
                width: 100%;
              ">
      <div style="margin: 5px" @click="Backward">
        <el-button size="mini"><em class="fas fa-backward"></em> </el-button>
      </div>
      <div style="margin: 5px" @click="StepBackward">
        <el-button size="mini"><em class="fas fa-step-backward"></em>
        </el-button>
      </div>
      <div style="margin: 5px; font-size: 20px; text-align: center">
        {{ Hz }}<br />{{ Value }}
      </div>
      <div style="margin: 5px" @click="StepForward">
        <el-button size="mini"><em class="fas fa-step-forward"></em>
        </el-button>
      </div>
      <div style="margin: 5px" @click="Forward">
        <el-button size="mini"><em class="fas fa-forward"></em> </el-button>
      </div>
    </div>
    <span style="position: absolute; top: 10px; left: 50px">
      <span style="margin-top: 0px">{{
        `${this.timeChartMinMax[0].toFixed(
          2
        )} - ${this.timeChartMinMax[1].toFixed(2)}
              ${$t("common.second")}`
      }}</span>

      {{ ChartElectricalTimeMini }}
    </span>

    <span v-show="this.bearing && this.referenceFrequency" style="position: absolute; top: 48px; right: 50px">
      <span style="margin-left: 5px" @click="currentFrequncy = 'BPFO'">
        <el-button :type="currentFrequncy == 'BPFO' ? 'primary' : ''" size="mini">{{ $t("point.bpfo") }}
        </el-button>
      </span>
      <span style="margin-left: 5px" @click="currentFrequncy = 'BPFI'">
        <el-button :type="currentFrequncy == 'BPFI' ? 'primary' : ''" size="mini">{{ $t("point.bpfi") }}
        </el-button>
      </span>
      <span style="margin-left: 5px" @click="currentFrequncy = 'FTF'">
        <el-button :type="currentFrequncy == 'FTF' ? 'primary' : ''" size="mini">{{ $t("point.ftf") }}</el-button>
      </span>
      <span style="margin-left: 5px" @click="currentFrequncy = 'BSF'">
        <el-button :type="currentFrequncy == 'BSF' ? 'primary' : ''" size="mini">{{ $t("point.bsf") }}</el-button>
      </span>
    </span>

    <span style="position: absolute; top: 10px; right: 50px">
      <span>
        <span style="margin-top: 0px">Zoom: {{ zoomLevel + 1 }}X</span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomIn">
          <el-button size="mini"><em class="fas fa-search-plus"></em> </el-button></span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomOut">
          <el-button size="mini"><em class="fas fa-search-minus"></em> </el-button></span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomReset">
          <el-button size="mini"><em class="fas fa-home"></em> </el-button></span>
        <span style="margin-left: 5px; z-index: 9999">
          <el-dropdown size="mini" @command="handleCommand" trigger="click">
            <el-button size="mini">
              {{ $t("common.download") }}
              <em class="fas fa-download"></em>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="csvDownload">
                {{ $t("common.csvDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="pngDownload">
                {{ $t("common.pngDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="svgDownload">
                {{ $t("common.svgDownload") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <br />
      </span>
    </span>
    <el-row class="toolbox">
      <el-col>
        <el-form ref="form" inline label-position="top" label-width="100px" size="small">
          <el-form-item :label="$t('measurement.harmonics')">
            <el-switch v-model="harmonics" @change="drawHarmonics()">
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('chart.XAxisUnit')">
            <el-radio-group v-model="freqType" size="mini">
              <el-radio-button label="Frequency">{{
                $t("chart.ftFrequency")
              }}</el-radio-button>
              <el-radio-button label="RPM">{{
                $t("chart.fRPM")
              }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('measurement.window')">
            <el-select v-model="window">
              <el-option v-for="window in windows" :key="window" :label="window" :value="window" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('measurement.bandpass') + ' [' + frange + ']'">
            <el-slider v-model="frange" @change="init" range :min="100" :max="bandpassMax"></el-slider>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import { apexDownload, Keyboard } from "../util";
import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini";
export default {
  name: "envelope-chart",
  events: [],
  props: {
    bearing: {
      type: Object,
    },
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
    referenceFrequency: {
      type: Number,
    },
    sensor: {
      type: String,
    },
  },
  components: {
    ChartTimeMini,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      visibleRange: [],
      mouseBeforeX: 0,
      mouseAfterX: 0,
      timeChartMinMax: [0, 0],
      freqType: "Frequency",
      chartLoading: true,
      activeDataPointIndex: 0,
      activeData: "",
      zoomLevel: 0,
      harmonics: true,
      zoomOffset: 20,
      window: "rectangular",
      TimeSerie: [],
      bandpassMax: 6000,
      frange: [0, 6000],
      timeSeries: [
        {
          data: [],
        },
      ],
      series: [
        {
          data: [],
        },
      ],
      currentFrequncy: "",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
      anootationPosition: 0,
      chartOptions: {
        tooltip: {
          enabled: true,
          shared: true,
          followCursor: false,
          style: {
            fontSize: "10px",
            fontFamily: undefined,
          },
          onDatasetHover: {},
          x: {
            show: false,
          },
          marker: {
            show: false,
          },
        },
        chart: {
          offsetY: 20,
          parentHeightOffset: -20,
          id: "chart",
          type: "line",
          defaultLocale: "en",
          locales: [
            {
              name: "en",
              options: {
                toolbar: {
                  exportToSVG: this.$t("chart.toolbar.exportToSVG"),
                  exportToPNG: this.$t("chart.toolbar.exportToPNG"),
                  exportToCSV: this.$t("chart.toolbar.exportToCSV"),
                  menu: this.$t("chart.toolbar.menu"),
                  selection: this.$t("chart.toolbar.selection"),
                  selectionZoom: this.$t("chart.toolbar.selectionZoom"),
                  zoomIn: this.$t("chart.toolbar.zoomIn"),
                  zoomOut: this.$t("chart.toolbar.zoomOut"),
                  pan: this.$t("chart.toolbar.pan"),
                  reset: this.$t("chart.toolbar.reset"),
                },
              },
            },
          ],
          zoom: {
            autoScaleYaxis: true,
          },
          events: {
            click: this.dataPointClick,
            updated: this.chartUpdated,
          },
          animations: {
            enabled: false,
            dynamicAnimation: {
              enabled: false,
            },
          },
          toolbar: {
            tools: {
              download: false,
              pan: true,
              zoom: false,
              zoomin: false,
              zoomout: false,
              reset: false,
            },
            autoSelected: "pan",
            show: true,
          },
        },
        annotations: {
          xaxis: [],
        },
        colors: ["#0071BD"],
        stroke: {
          width: 2,
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          type: "numeric",
          tickAmount: 20,
        },
        yaxis: {
          labels: {
            formatter: function (e) {
              return parseFloat(e).toFixed(2);
            },
          },
        },
        grid: {
          show: !0,
          padding: {
            top: 50,
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        theme: {},
      },
    };
  },
  mounted() {
    let nyq = parseInt(this.samplingRate / 2);
    this.bandpassMax = parseInt(nyq - 50);
    this.frange = [0, this.bandpassMax];
    this.visibleRange = [0, this.rawData.length - 1];
    window.addEventListener("mousedown", this.mouseDown);
    this.timeSeries = [
      {
        name: name,
        data: this.rawData,
      },
    ];
  },
  computed: {
    sensorUnit: function () {
      switch (this.sensor) {
        case "current":
          return "A";
        case "voltage":
          return "V";
      }
      return "G";
    },
    ...mapState("measurementsDetails", ["rawdataIndex"]),
    Hz: function () {
      if (!this.activeData.length) return "";
      return (
        Number(this.frequencyDomain[this.activeDataPointIndex]).toFixed(4) +
        `Hz`
      );
    },
    Value: function () {
      try {
        if (!this.activeData.length) return "";
        else {
          return this.activeData[this.activeDataPointIndex].toFixed(4);
        }
      } catch (e) {
        return 0;
      }
    },
  },
  methods: {
    chartUpdated() {
      this.BindKeyborad();
      this.chartLoading = false;
      this.drawAnnotations();
    },
    updateTimeChartMinMax(timeDomain) {
      this.timeChartMinMax = timeDomain;
    },
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    handleCommand(command) {
      switch (command) {
        case "csvDownload":
          apexDownload.csvDownload(this, "apexEnvelope");
          break;
        case "pngDownload":
          apexDownload.pngDownload(this);
          break;
        case "svgDownload":
          apexDownload.svgDownload(this);
          break;
      }
      setTimeout(() => {
        this.init();
      }, 100);
    },
    visibilityChanged(a) {
      if (a) {
        this.init();
      }
    },
    DC_Offset(data) {
      const average = data.reduce((p, c) => p + c, 0) / data.length; // calculate average
      var normalized = data.map((x) => x - average); // normalize raw data by subtracting average and multiplying by gravity constant
      return normalized;
    },
    init() {
      this.chartLoading = true;
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/envelope`, {
          xlim: 2500,
          half: true,
          dcOffset: true,
          window: this.window,
          frequencyRange: this.frange,
          signal: this.rawData.slice(
            this.visibleRange[0],
            this.visibleRange[1]
          ),
          samplingRate: this.samplingRate,
        })
        .then((response) => {
          this.frequencyDomain = response.data.results.x;
          this.activeData = response.data.results.y;
          if (this.freqType == "Frequency") {
            this.frequencyDomain = this.frequencyDomain.map((a) => a);
          } else {
            this.frequencyDomain = this.frequencyDomain.map((x) => x * 60);
          }
          this.PrepareDataToPlot().then(() => {
            this.$refs.apexEnvelope.zoomX(
              this.frequencyDomain[0],
              this.frequencyDomain[this.frequencyDomain.length - 1]
            );
            this.zoom();
          });
        });
    },
    async PrepareDataToPlot() {
      let name = "envelope";
      this.chartOptions = {
        xaxis: {
          title: {
            text: `${this.$t("chart.fFrequency")}`,
            offsetY: 70,
          },
          categories: this.frequencyDomain,
          labels: {
            formatter: function (val) {
              if (val) {
                return val.toFixed(2);
              } else {
                return "";
              }
            },
          },
        },
        yaxis: {
          tickAmount: 10,
          title: {
            text: "gE",
          },
          labels: {
            formatter: function (e) {
              return parseFloat(e).toFixed(4);
            },
          },
        },
      };
      this.series = [
        {
          name: name,
          data: this.activeData,
        },
      ];
    },
    dataPointClick(event, chartContext, config) {
      this.mouseAfterX = event.offsetX;
      if (
        Math.abs(this.mouseAfterX - this.mouseBeforeX) < 5 &&
        !event.ctrlKey
      ) {
        this.$message({
          type: "info",
          message: this.$t("chart.warningForCTRLClick"),
        });
      }
      if (event.ctrlKey) {
        if (config.dataPointIndex == -1) return;
        this.$refs.apexEnvelope.clearAnnotations();
        this.activeDataPointIndex = config.dataPointIndex;
        this.drawAnnotations();
      }
    },
    drawHarmonics() {
      this.$refs.apexEnvelope.removeAnnotation("harmonics");
      if (this.harmonics) {
        try {
          let freq_index = this.frequencyDomain[this.activeDataPointIndex];

          switch (this.currentFrequncy) {
            case "BPFO":
              let bpfo = this.referenceFrequency * this.bearing.bpfo * 60;
              bpfo = this.freqType.toUpperCase() == "RPM" ? bpfo * 60 : bpfo;
              freq_index = bpfo;
              break;
            case "BPFI":
              let bpfi = this.referenceFrequency * this.bearing.bpfi * 60;
              bpfi = this.freqType.toUpperCase() == "RPM" ? bpfi * 60 : bpfi;
              freq_index = bpfi;
              break;
            case "FTF":
              const isFTF = !!this.bearing.ftf;
              let ftf =
                this.referenceFrequency * isFTF
                  ? this.referenceFrequency * this.bearing.ftf
                  : this.referenceFrequency * this.bearing.ftfi;
              ftf = this.freqType.toUpperCase() == "RPM" ? (ftf * 60)*60  : ftf;
              freq_index = ftf;
              break;
            case "BSF":
              let bsf = this.referenceFrequency * this.bearing.bsf * 60;
              bsf = this.freqType.toUpperCase() == "RPM" ? bsf * 60 : bsf;
              freq_index = bsf;
              break;
          }

          for (var i = 1; i <= 10; i++) {
            var x = freq_index * i;
            let annotation = {
              id: "harmonics",
              x,
              borderColor: "#775DD0",
              label: {
                style: {
                  background: "#fff",
                  color: "#777",
                  fontSize: "12px",
                  fontWeight: 400,
                  fontFamily: undefined,
                  cssClass: "apexcharts-xaxis-annotation-label",
                },
                text: `${i}x${this.currentFrequncy}`,
                orientation: "horizontal",
              },
            };
            this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
          }
        } catch (e) {
          //console.error(e);
        }
      }
    },
    drawPeak() {
      try {
        if (
          this.activeData[this.activeDataPointIndex] >
          this.activeData[this.activeDataPointIndex - 1] &&
          this.activeData[this.activeDataPointIndex] >
          this.activeData[this.activeDataPointIndex + 1]
        ) {
          this.maxPointValue = this.activeData[this.activeDataPointIndex];
          this.maxPointFreq = this.frequencyDomain[this.activeDataPointIndex];
          let maxPointAnnotation = {
            x: this.maxPointFreq,
            y: this.maxPointValue,
            marker: {
              size: 2,
            },

            image: {
              path: "/images/peak.png",
              size: 5,
            },
          };
          this.$refs.apexEnvelope.addPointAnnotation(maxPointAnnotation, false);
        }
      } catch (e) {
        console.log(e);
      }
    },
    drawReferenceFrequency() {
      try {
        let ref = this.referenceFrequency;
        ref = this.freqType.toUpperCase() == "RPM" ? ref * 60 : ref;
        let annotation = {
          x: ref,
          offsetY: -40,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -40,

            style: {
              background: "#00c500",
              color: "white",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `REF(${ref.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
      } catch (e) {
        console.error(e);
      }
    },
    drawBPFO() {
      try {
        let bpfo = this.referenceFrequency * this.bearing.bpfo * 60;
        bpfo = this.freqType.toUpperCase() == "RPM" ? bpfo * 60 : bpfo;
        let annotation = {
          x: bpfo,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,

            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BPFO (${bpfo.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawBSF() {
      try {
        let bsf = this.referenceFrequency * this.bearing.bsf * 60;
        bsf = this.freqType.toUpperCase() == "RPM" ? bsf * 60 : bsf;
        let annotation = {
          x: bsf,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BSF (${bsf.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawBPFI() {
      try {
        let bpfi = this.referenceFrequency * this.bearing.bpfi * 60;
        bpfi = this.freqType.toUpperCase() == "RPM" ? bpfi * 60 : bpfi;
        let annotation = {
          x: bpfi,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,

            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BPFI (${bpfi.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawFTF(isFTF) {
      try {
        let ftf =
          this.referenceFrequency * isFTF
            ? this.referenceFrequency * this.bearing.ftf
            : this.referenceFrequency * this.bearing.ftfi;
        ftf = this.freqType.toUpperCase() == "RPM" ? (ftf * 60)*60  : ftf;
        let annotation = {
          x: ftf,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `${isFTF ? "FTF" : "FTFI"} (${ftf.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexEnvelope.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawAnnotations() {
      this.$refs.apexEnvelope.clearAnnotations();
      if (this.referenceFrequency) {
        this.drawReferenceFrequency();
      }
      if (this.bearing && this.referenceFrequency) {
        switch (this.currentFrequncy) {
          case "BPFO":
            this.drawBPFO();
            break;
          case "BSF":
            this.drawBSF();
            break;
          case "BPFI":
            this.drawBPFI();
            break;
          case "FTF":
            this.drawFTF(!!this.bearing.ftf);
            break;
        }
      }
      this.drawHarmonics();
      this.drawPeak();
    },
    Backward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 10;
      this.drawAnnotations();
    },
    Forward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 10;
      this.drawAnnotations();
    },
    StepBackward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 1;
      this.drawAnnotations();
    },
    StepForward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 1;
      this.drawAnnotations();
    },
    BindKeyborad() {
      Keyboard.detach(this.$refs.apexEnvelope.$el);
      Keyboard.attach(this.$refs.apexEnvelope.$el);
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowLeft",
        callback: this.Backward,
      });
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowRight",
        callback: this.Forward,
      });
      Keyboard.add_binding({
        key: "ArrowLeft",
        callback: this.StepBackward,
      }),
        Keyboard.add_binding({
          key: "ArrowRight",
          callback: this.StepForward,
        });
      Keyboard.add_binding({
        key: "Enter",
        callback: () => {
          this.zoomReset();
        },
      });
      Keyboard.add_binding({
        key: "ArrowUp",
        callback: () => {
          this.zoomIn();
        },
      });
      Keyboard.add_binding({
        key: "ArrowDown",
        callback: () => {
          this.zoomOut();
        },
      });
      this.drawAnnotations();
    },
    zoomIn() {
      if (this.zoomLevel + 1 > this.maxZoomLevel) {
        return;
      }
      this.zoomLevel = this.zoomLevel + 1;
      this.zoom();
    },
    zoomOut() {
      if (this.zoomLevel - 1 < 0) {
        return;
      }
      this.zoomLevel = this.zoomLevel - 1;
      this.zoom();
    },
    zoomReset() {
      this.zoomLevel = 0;
      this.zoom();
    },
    zoom() {
      let offset =
        this.frequencyDomain[this.frequencyDomain.length - 1] /
        Math.pow(2, this.zoomLevel);
      let centerValue = this.frequencyDomain[this.activeDataPointIndex];
      let min = centerValue - offset;
      let max = centerValue + offset;
      if (min < 0) min = this.frequencyDomain[0];
      if (this.zoomLevel == 0) {
        this.$refs.apexEnvelope.zoomX(
          this.frequencyDomain[0],
          this.frequencyDomain[this.frequencyDomain.length - 1]
        );
      } else {
        this.$refs.apexEnvelope.zoomX(min, max);
      }

      this.drawAnnotations();
    },
  },
  watch: {
    currentFrequncy: function () {
      this.drawAnnotations();
    },
    referenceFrequency: function () {
      this.drawAnnotations();
    },
    visibleRange: function (range) {
      this.init();
    },
    freqType: function () {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    rawData: function () {
      this.init();
    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}

*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>